import React from 'react' ;
// import bgp from '../images/bg-product.png';





export default function About() {

    return(

        <>
         <div className="pre-header-page"></div>
         <div className="header-page">
           <span className="header-page-title">ABOUT US</span>
           {/* <h4>SCROLL TO EXPLORE</h4> */}
         </div>
          <h1> ABOUT PAGE </h1>
        </>
    );
};

